exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".title___Qa7wE {\n  margin-top: 0;\n  font-family: 'poynter-oldstyle-display', serif;\n  font-size: 24px;\n  line-height: 32px;\n}\n@media (min-width: 992px) {\n  .title___Qa7wE {\n    font-size: 32px;\n    line-height: 40px;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"title": "title___Qa7wE"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/components/manage/guestlist/addressCollection/ConfigureAddressCollectionHeader/ConfigureAddressCollectionHeader.module.less
// module id = 2341
// module chunks = 71